// extracted by mini-css-extract-plugin
export default {"root":"ce4Qi"};